import { useEffect, useRef } from 'react'

import {
  Page,
  Side,
  SideProps,
  Token,
  useMatchMedia,
  useToggle,
} from '@revolut-internal/ui-kit'

import { useAlertingPoliciesQuery } from 'modules/api/alerting/queries'

import { QueueHealthPolicy } from './QueueHealthPolicy/QueueHealthPolicy'
import { QueueHealthAllResources, QueueHealthAllResourcesProps } from './resouces'

type QueueHealthResourcesSideProps = Required<Pick<SideProps, 'onClose'>> &
  Omit<
    QueueHealthAllResourcesProps,
    'scrollRef' | 'policy' | 'isPolicyPending' | 'onPolicyShow'
  >

export const QueueHealthResourcesSide = ({
  queueHealthSpecialisations,
  resourcesSideParams,
  onResourceChange,
  onClose,
}: QueueHealthResourcesSideProps) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [isPolicyView, toggleIsPolicyView] = useToggle({ defaultState: false })
  const open = Boolean(resourcesSideParams)
  const isLargeScreen = useMatchMedia(Token.media.xxl)

  const { data: policy, isPending: isPolicyPending } = useAlertingPoliciesQuery({
    specialisation: resourcesSideParams?.specialisation,
  })

  useEffect(() => {
    if (open) {
      return
    }

    toggleIsPolicyView.off()
  }, [open, toggleIsPolicyView])

  useEffect(() => {
    if (!open || !isPolicyView) {
      return
    }

    toggleIsPolicyView.off()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourcesSideParams])

  return (
    <Page.Side behaviour="cover" usePortal>
      <Side
        variant={isLargeScreen ? 'wide' : 'medium'}
        open={open}
        scrollRef={scrollRef}
        onClose={onClose}
      >
        {isPolicyView ? (
          <QueueHealthPolicy
            scrollRef={scrollRef}
            specialisation={resourcesSideParams?.specialisation}
            policy={policy}
            isPolicyPending={isPolicyPending}
            onBack={toggleIsPolicyView.off}
          />
        ) : (
          <QueueHealthAllResources
            scrollRef={scrollRef}
            queueHealthSpecialisations={queueHealthSpecialisations}
            resourcesSideParams={resourcesSideParams}
            policy={policy}
            isPolicyPending={isPolicyPending}
            onResourceChange={onResourceChange}
            onPolicyShow={toggleIsPolicyView.on}
          />
        )}
      </Side>
    </Page.Side>
  )
}
